export const STORE_KEY = '@@user'

export const LOGIN_REQUEST = `${STORE_KEY}/LOGIN_REQUEST`
export const LOGIN_SUCCESS = `${STORE_KEY}/LOGIN_SUCCESS`
export const LOGIN_FAILURE = `${STORE_KEY}/LOGIN_FAILURE`
export const FETCH_OCA_USER_REQUEST = `${STORE_KEY}/FETCH_OCA_USER_REQUEST`
export const FETCH_OCA_USER_SUCCESS = `${STORE_KEY}/FETCH_OCA_USER_SUCCESS`
export const FETCH_OCA_USER_FAILURE = `${STORE_KEY}/FETCH_OCA_USER_FAILURE`
export const LOGOUT_REQUEST = `${STORE_KEY}/LOGOUT_REQUEST`
export const LOGOUT_SUCCESS = `${STORE_KEY}/LOGOUT_SUCCESS`
export const LOGOUT_FAILURE = `${STORE_KEY}/LOGOUT_FAILURE`
export const REGISTER_REQUEST = `${STORE_KEY}/REGISTER_REQUEST`
export const REGISTER_SUCCESS = `${STORE_KEY}/REGISTER_SUCCESS`
export const REGISTER_FAILURE = `${STORE_KEY}/REGISTER_FAILURE`
export const GET_USER_FACEBOOK_REQUEST = `${STORE_KEY}/GET_USER_FACEBOOK_REQUEST`
export const GET_USER_FACEBOOK_SUCCESS = `${STORE_KEY}/GET_USER_FACEBOOK_SUCCESS`
export const GET_USER_FACEBOOK_FAILURE = `${STORE_KEY}/GET_USER_FACEBOOK_FAILURE`
export const GET_USER_REQUEST = `${STORE_KEY}/GET_USER_REQUEST`
export const GET_USER_SUCCESS = `${STORE_KEY}/GET_USER_SUCCESS`
export const GET_USER_FAILURE = `${STORE_KEY}/GET_USER_FAILURE`
export const UPDATE_USER_REQUEST = `${STORE_KEY}/UPDATE_USER_REQUEST`
export const UPDATE_USER_SUCCESS = `${STORE_KEY}/UPDATE_USER_SUCCESS`
export const UPDATE_USER_FAILURE = `${STORE_KEY}/UPDATE_USER_FAILURE`
export const UPDATE_USER_PASSWORD_REQUEST = `${STORE_KEY}/UPDATE_USER_PASSWORD_REQUEST`
export const UPDATE_USER_PASSWORD_SUCCESS = `${STORE_KEY}/UPDATE_USER_PASSWORD_SUCCESS`
export const UPDATE_USER_PASSWORD_FAILURE = `${STORE_KEY}/UPDATE_USER_PASSWORD_FAILURE`
export const RESET_PASSWORD_REQUEST = `${STORE_KEY}/RESET_PASSWORD_REQUEST`
export const RESET_PASSWORD_SUCCESS = `${STORE_KEY}/RESET_PASSWORD_SUCCESS`
export const RESET_PASSWORD_FAILURE = `${STORE_KEY}/RESET_PASSWORD_FAILURE`
export const SET_DEFAULT_USER_DELIVERY_ADDRESS_REQUEST = `${STORE_KEY}/SET_DEFAULT_USER_DELIVERY_ADDRESS_REQUEST`
export const SET_DEFAULT_USER_DELIVERY_ADDRESS_SUCCESS = `${STORE_KEY}/SET_DEFAULT_USER_DELIVERY_ADDRESS_SUCCESS`
export const SET_DEFAULT_USER_DELIVERY_ADDRESS_FAILURE = `${STORE_KEY}/SET_DEFAULT_USER_DELIVERY_ADDRESS_FAILURE`
export const CREATE_USER_DELIVERY_ADDRESS_REQUEST = `${STORE_KEY}/CREATE_USER_DELIVERY_ADDRESS_REQUEST`
export const CREATE_USER_DELIVERY_ADDRESS_SUCCESS = `${STORE_KEY}/CREATE_USER_DELIVERY_ADDRESS_SUCCESS`
export const CREATE_USER_DELIVERY_ADDRESS_FAILURE = `${STORE_KEY}/CREATE_USER_DELIVERY_ADDRESS_FAILURE`
export const UPDATE_USER_DELIVERY_ADDRESS_REQUEST = `${STORE_KEY}/UPDATE_USER_DELIVERY_ADDRESS_REQUEST`
export const UPDATE_USER_DELIVERY_ADDRESS_SUCCESS = `${STORE_KEY}/UPDATE_USER_DELIVERY_ADDRESS_SUCCESS`
export const UPDATE_USER_DELIVERY_ADDRESS_FAILURE = `${STORE_KEY}/UPDATE_USER_DELIVERY_ADDRESS_FAILURE`
export const REMOVE_USER_DELIVERY_ADDRESS_REQUEST = `${STORE_KEY}/REMOVE_USER_DELIVERY_ADDRESS_REQUEST`
export const REMOVE_USER_DELIVERY_ADDRESS_SUCCESS = `${STORE_KEY}/REMOVE_USER_DELIVERY_ADDRESS_SUCCESS`
export const REMOVE_USER_DELIVERY_ADDRESS_FAILURE = `${STORE_KEY}/REMOVE_USER_DELIVERY_ADDRESS_FAILURE`
export const GET_USER_ORDER_REQUEST = `${STORE_KEY}/GET_USER_ORDER_REQUEST`
export const GET_USER_ORDER_SUCCESS = `${STORE_KEY}/GET_USER_ORDER_SUCCESS`
export const GET_USER_ORDER_FAILURE = `${STORE_KEY}/GET_USER_ORDER_FAILURE`
export const CHECK_USER_EXISTENCE_REQUEST = `${STORE_KEY}/CHECK_USER_EXISTENCE_REQUEST`
export const CHECK_USER_EXISTENCE_SUCCESS = `${STORE_KEY}/CHECK_USER_EXISTENCE_SUCCESS`
export const CHECK_USER_EXISTENCE_FAILURE = `${STORE_KEY}/CHECK_USER_EXISTENCE_FAILURE`
export const VERIFY_OTP_REQUEST = `${STORE_KEY}/VERIFY_OTP_REQUEST`
export const VERIFY_OTP_SUCCESS = `${STORE_KEY}/VERIFY_OTP_SUCCESS`
export const VERIFY_OTP_FAILURE = `${STORE_KEY}/VERIFY_OTP_FAILURE`
export const RESEND_OTP_REQUEST = `${STORE_KEY}/RESEND_OTP_REQUEST`
export const RESEND_OTP_SUCCESS = `${STORE_KEY}/RESEND_OTP_SUCCESS`
export const RESEND_OTP_FAILURE = `${STORE_KEY}/RESEND_OTP_FAILURE`
export const SEND_OTP_REQUEST = `${STORE_KEY}/SEND_OTP_REQUEST`
export const SEND_OTP_SUCCESS = `${STORE_KEY}/SEND_OTP_SUCCESS`
export const SEND_OTP_FAILURE = `${STORE_KEY}/SEND_OTP_FAILURE`
export const CREATE_LOYALTY_CUSTOMER_REQUEST = `${STORE_KEY}/CREATE_LOYALTY_CUSTOMER_REQUEST`
export const CREATE_LOYALTY_CUSTOMER_SUCCESS = `${STORE_KEY}/CREATE_LOYALTY_CUSTOMER_SUCCESS`
export const CREATE_LOYALTY_CUSTOMER_FAILURE = `${STORE_KEY}/CREATE_LOYALTY_CUSTOMER_FAILURE`
export const ODDLE_PASS_LOGIN_SUCCESS = `${STORE_KEY}/ODDLE_PASS_LOGIN_SUCCESS`
export const ODDLE_PASS_LOGOUT_SUCCESS = `${STORE_KEY}/ODDLE_PASS_LOGOUT_SUCCESS`
export const GET_ALL_ADDRESSES_FROM_OP_REQUEST = `${STORE_KEY}/GET_ALL_ADDRESSES_FROM_OP_REQUEST`
export const GET_ALL_ADDRESSES_FROM_OP_SUCCESS = `${STORE_KEY}/GET_ALL_ADDRESSES_FROM_OP_SUCCESS`
export const GET_ALL_ADDRESSES_FROM_OP_FAILURE = `${STORE_KEY}/GET_ALL_ADDRESSES_FROM_OP_FAILURE`
export const GET_ALL_SAVED_CARDS_FROM_OP_REQUEST = `${STORE_KEY}/GET_ALL_SAVED_CARDS_FROM_OP_REQUEST`
export const GET_ALL_SAVED_CARDS_FROM_OP_SUCCESS = `${STORE_KEY}/GET_ALL_SAVED_CARDS_FROM_OP_SUCCESS`
export const GET_ALL_SAVED_CARDS_FROM_OP_FAILURE = `${STORE_KEY}/GET_ALL_SAVED_CARDS_FROM_OP_FAILURE`
export const REMOVE_SAVED_CARD_FROM_OP_REQUEST = `${STORE_KEY}/REMOVE_SAVED_CARD_FROM_OP_REQUEST`
export const REMOVE_SAVED_CARD_FROM_OP_SUCCESS = `${STORE_KEY}/REMOVE_SAVED_CARD_FROM_OP_SUCCESS`
export const REMOVE_SAVED_CARD_FROM_OP_FAILURE = `${STORE_KEY}/REMOVE_SAVED_CARD_FROM_OP_FAILURE`
export const SET_CARD_DEFAULT_FROM_OP_REQUEST = `${STORE_KEY}/SET_CARD_DEFAULT_FROM_OP_REQUEST`
export const SET_CARD_DEFAULT_FROM_OP_SUCCESS = `${STORE_KEY}/SET_CARD_DEFAULT_FROM_OP_SUCCESS`
export const SET_CARD_DEFAULT_FROM_OP_FAILURE = `${STORE_KEY}/SET_CARD_DEFAULT_FROM_OP_FAILURE`
export const GET_ACCESS_TOKEN_REQUEST = `${STORE_KEY}/GET_ACCESS_TOKEN_REQUEST`
export const GET_ACCESS_TOKEN_SUCCESS = `${STORE_KEY}/GET_ACCESS_TOKEN_SUCCESS`
export const GET_ACCESS_TOKEN_FAILURE = `${STORE_KEY}/GET_ACCESS_TOKEN_FAILURE`
